import { AppBar, Tab } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import { DashboardStyleClasses } from "assets/jss/common-styles";
import { AppBarTabs } from "components/AppTabs";
import MuiContainer from "components/MuiExtras/MuiContainer";
import * as React from "react";
import Session from "services/Session";
import UserAwards from "views/Dashboards/AwardsAndCreditsDashboard/UserAwards";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    currentTab: TabOptions,
}

type Props = {} & WithStyles<typeof DashboardStyleClasses>

enum TabOptions { Awards, Credits }

/////////////////////////////////////////////////////////////////////////////////////

class AwardsAndCreditsDashboard extends React.PureComponent<Props, IState> {

    private tabs: Array<React.ReactElement> = [];

    constructor(props: Props) {
        super(props);

        let initialTab: TabOptions = null;

        this.tabs.push(<Tab key={TabOptions.Awards} value={TabOptions.Awards} label="Suas Premiações" />);
        initialTab = TabOptions.Awards;

        this.state = {
            currentTab: initialTab
        };
    }

    ///
    private handleTabSelection = (event: React.ChangeEvent<{}>, value: any) => {
        this.setState({ currentTab: value });
    }

    ///
    private renderFormMenuBar(): JSX.Element {

        return (
            <MuiContainer margin="dense">
                <AppBar position="static" color="primary"  >
                    <AppBarTabs centered value={this.state.currentTab} onChange={this.handleTabSelection}>
                        {this.tabs}
                    </AppBarTabs>
                </AppBar>
            </MuiContainer>
        );
    }

    /////////////////////////////////////////////////////////////////////////////////////

    render() {
        return (
            <div className={this.props.classes.dashboardContainer}>

                {
                    //this.renderFormMenuBar()
                }

                {
                    this.state.currentTab == TabOptions.Awards
                        ? <UserAwards userId={Session.user.id} classes={this.props.classes} />
                        : null
                }

            </div>
        );
    }
}

export default withStyles(DashboardStyleClasses)(AwardsAndCreditsDashboard);